// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/sbg-debt-announcements/sbg-debt-announcements.component.scss
// module id = 774
// module chunks = 0